import { api } from "../../../lib/api.js";
import type { DocSummary } from "../../knowledge-base/types.js";

/**
 * Trainings, through this app's BFF (`GET /api/trainings` → portal-api
 * `GET /api/v1/reseller/trainings`). portal-api has already decided which
 * trainings this company may read and ordered them newest release first; the
 * page groups and searches what comes back and decides nothing.
 *
 * Read through `lib/api.ts` so a 403 surfaces as the portal's usual
 * "no access" panel, like Documentation.
 */
export async function listTrainings(): Promise<DocSummary[]> {
  const body = await api<{ data?: DocSummary[] }>("/api/trainings");
  return body.data ?? [];
}
